// Disable eslint because this code was not written with lint in mind, and was ported in. It needs to be fixed at some point.
/* eslint-disable */
import { IUser, UserHeader } from '../user';
import { Token, TokenClass, TokenParameters, TokenType } from './token';

export class EmailTokenParameters extends TokenParameters {
  constructor(
    public readonly password: string,
    public readonly scopes: Array<string>
  ) {
    super();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toStorageItem(user: IUser): any {
    let type = TokenClass.email;
    if (this.scopes.length > 0) {
      type = TokenClass.scopedEmail;
    }
    return {
      type: type,
      id: user.id,
      username: user.username,
      email: user.email,
      password: this.password,
      scopes: this.scopes,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromStorageItem(item: any): EmailToken {
    let email = item['email'];
    if (!email) {
      email = '';
    }
    return new EmailToken(
      new UserHeader(item['id'], item['username'], email),
      new EmailTokenParameters(item['password'], item['scopes'])
    );
  }
}

export class EmailToken extends Token {
  private _header: IUser;
  private readonly _parameters: EmailTokenParameters;

  constructor(header: IUser, parameters: EmailTokenParameters) {
    super(TokenType.originating, parameters.scopes.length > 0 ? TokenClass.scopedEmail : TokenClass.email);
    this._header = header;
    this._parameters = parameters;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  exchange(_: string, __: string, ___: Array<string>): Promise<Token> {
    return Promise.reject('Unsupported');
  }

  expire(): Promise<void> {
    return Promise.resolve(undefined);
  }

  get expired(): boolean {
    return false;
  }

  get expires(): number {
    return 0;
  }

  get header(): string | null {
    return `Basic ${this.token}`;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  initialize(_: Token | null, __: (token: Token) => void): void {}

  get initialized(): boolean {
    return true;
  }

  get invalid(): boolean {
    return false;
  }

  get originatingId(): string | null {
    return this._header.username;
  }

  refresh(): Promise<Token> {
    return Promise.resolve(this);
  }

  get refreshToken(): string {
    return '';
  }

  get refreshable(): boolean {
    return false;
  }

  get scopes(): Array<string> {
    return this._parameters.scopes;
  }

  setValid(): Promise<void> {
    return Promise.resolve(undefined);
  }

  toParameters(): TokenParameters {
    return this._parameters;
  }

  get user(): IUser {
    return this._header;
  }

  set user(user: IUser) {
    this._header = user;
  }

  get willExpireSoon(): boolean {
    return false;
  }

  get token(): string {
    return btoa(`${this.user.username}:${this._parameters.password}`);
  }
}
